import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PagesProvider from "../../pages/pagesProvider/PagesProvider";
import LogoutModal from "../mainModals/LogoutModal";
import SessionEndModal from "../mainModals/SessionEndModal";
import DisabledAccountModal from "../mainModals/DisabledAccountModal";
import { useSelector } from "react-redux";
import FallbackLoader from "../common/loader/FallbackLoader";
import environment from "../../environment";
import { jwtDecode } from "jwt-decode";
import { getRefreshToken } from "../../helpers/getRefreshToken";

const Layout = () => {
  const accessToken = localStorage.getItem(environment.TOKEN_KEY);
  const refreshToken = localStorage.getItem(environment.REFRESH_TOKEN_KEY);
  const decodeToken = () => accessToken && jwtDecode(accessToken);
  const decodedToken = decodeToken();

  // if has an error to dispatch modal
  const ShowLogoutModalHandler = useSelector((state) => state.error.logout);

  const ShowSessionEndModalHandler = useSelector(
    (state) => state.error.sessionEnd
  );

  const ShowDisabledAccountModalHandler = useSelector(
    (state) => state.error.disabledAccount
  );
  const location = useLocation();
  useEffect(() => {
    const currentTime = Date.now() / 1000;
    if (decodedToken?.exp <= currentTime) {
      getRefreshToken(refreshToken);
    }
  }, [location]);
  return (
    <Suspense fallback={<FallbackLoader />}>
      <PagesProvider>
        <Outlet />
      </PagesProvider>
      <LogoutModal show={ShowLogoutModalHandler} />
      <SessionEndModal show={ShowSessionEndModalHandler} />
      <DisabledAccountModal show={ShowDisabledAccountModalHandler} />
    </Suspense>
  );
};

export default Layout;
